module.exports = __webpack_public_path__ + "img/King@2x.68f0791e.png";